var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookmarkFill = function SvgBookmarkFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_5632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 18.75C15.4721 18.7504 15.3244 18.6949 15.2098 18.5938L10 13.9613L4.79024 18.5938C4.70008 18.6739 4.58866 18.7262 4.46942 18.7445C4.35017 18.7627 4.22821 18.746 4.11823 18.6964C4.00825 18.6469 3.91497 18.5666 3.84963 18.4652C3.78429 18.3638 3.74969 18.2456 3.75 18.125V3.75C3.75073 3.08718 4.01435 2.45172 4.48303 1.98303C4.95172 1.51435 5.58718 1.25072 6.25 1.25H13.75C14.4128 1.25072 15.0483 1.51435 15.517 1.98303C15.9857 2.45172 16.2493 3.08718 16.25 3.75V18.125C16.25 18.2908 16.1842 18.4497 16.0669 18.5669C15.9497 18.6842 15.7908 18.75 15.625 18.75Z",
    fill: "#4ABF6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 1.5L12.8 6.5L11 4.5",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 1.5L12.8 6.5L11 4.5",
    stroke: "#4ABF6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_5632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmarkFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark-fill.dbad69a1.svg";
export { ForwardRef as ReactComponent };